// name of the constant = route name in lower case
const vehicledetail = [
  { title: 'Vehicle Number', tlabel: 'MDM_VEHICLE_NUMBER', type: 'input', paramKey: 'number', required: true, disabled: true },
  { title: 'Availability', tlabel: 'MDM_AVAILABILITY', paramKey: 'is_vehicle_available', required: true, disabled: false, type: 'switch', active_text: 'YES', inactive_text: 'NO' },
];

const users = [
  { title: 'Status', type: 'switch', paramKey: 'status', active_text: 'ACTIVE', inactive_text: 'INACTIVE' },
  { title: 'User Name', type: 'input', paramKey: 'name', required: true },
  { title: 'Phone Number', type: 'input', paramKey: 'mobile', required: true, inputType: 'number' },
  { title: 'Email Address', type: 'input', paramKey: 'email', required: true },
  { title: 'Role', type: 'dropdown', paramKey: 'role_id', required: true },
  {
    title: 'Depots Assigned',
    type: 'List',
    paramKey: 'depot_ids',
    options: [],
    required: false,
  },
];

// eslint-disable-next-line import/prefer-default-export
export const formConstants = {
  vehicledetail,
  users,
};
